import SyncIcon from '@mui/icons-material/Sync';
import { Box, Button, SxProps, Theme } from '@mui/material';

interface IResetUpdateButtonGroupProps {
    onReset: () => void;
    onSubmit: () => void;
    isResetDisabled: boolean;
    isUpdateDisabled: boolean;
    isSubmitting: boolean;
    containerStyle?: SxProps<Theme>;
    resetLabel?: string;
    updateLabel?: string;
}

export const ResetUpdateButtonGroup = ({
    onReset,
    onSubmit,
    isResetDisabled,
    isUpdateDisabled,
    isSubmitting,
    containerStyle,
    resetLabel = 'Reset',
    updateLabel = 'Update',
}: IResetUpdateButtonGroupProps) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 2,
                my: 1,
                ...containerStyle,
            }}
        >
            <Button variant="outlined" color="warning" onClick={onReset} disabled={isResetDisabled}>
                {resetLabel}
            </Button>
            <Button
                variant="contained"
                onClick={onSubmit}
                disabled={isUpdateDisabled}
                endIcon={isSubmitting && <SyncIcon />}
            >
                {updateLabel}
            </Button>
        </Box>
    );
};
